module.exports = __webpack_public_path__ + "static/media/repeat.60ee7450.svg";